import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedAnimation,
  setSelectedAnimationDetails,
} from "../../../app/slices/AnimationsSlice";
import { useAnimationDetails } from "./useAnimationAssets.hook";

export default function useAnimationLibrary() {
  const dispatch = useDispatch();
  const selectedAnimation = useSelector(selectSelectedAnimation);
  const { details } = useAnimationDetails(selectedAnimation?.externalId);

  useEffect(() => {
    if (!details) return;
    dispatch(setSelectedAnimationDetails(details));
  }, [details, dispatch]);
}
